import React, { Component } from 'react';
import './estilo.css';
import TaxiIcon from '../../img/taxiUbicacion1.png'
import PrivadoIcon from '../../img/privadoUbicacion.png'
import MicroIcon from '../../img/microbus.png'
import CoasterIcon from '../../img/coaster.png'
import firebase from 'firebase';
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker, lifecycle, InfoWindow } from "react-google-maps"
import { Eye } from 'react-preloading-component';


const google = window.google;
const Taxi = { url: TaxiIcon, scaledSize: new google.maps.Size(30, 35) };
const Privado = { url: PrivadoIcon, scaledSize: new google.maps.Size(30, 35) };
const Microbus = { url: MicroIcon, scaledSize: new google.maps.Size(30, 35) };
const Coaster = { url: CoasterIcon, scaledSize: new google.maps.Size(30, 35) };

const MyMapComponent = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `600px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    withScriptjs,
    withGoogleMap
)((props) =>
    <GoogleMap
        defaultZoom={14}
        defaultCenter={{ lat: 13.6988044, lng: -89.2507203 }}
    >
    </GoogleMap>
)

class UnidadesViajes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onTravelT: 0,
            onBoardingT: 0,
            isFinishT: 0,

            onTravelM: 0,
            onBoardingM: 0,
            isFinishM: 0,

            onTravelC: 0,
            onBoardingC: 0,
            isFinishC: 0,

            onTravelP: 0,
            onBoardingP: 0,
            isFinishP: 0,

            viajes: [],
            empleV: [],
            condV: [],
            isLoading: false
        };
    }

    cargarViajes = () => {
        firebase.database().ref('AsignacionViajes').on('value', snap => {
            let onTravelT = 0
            let onBoardingT = 0
            let isFinishT = 0

            let onTravelM = 0
            let onBoardingM = 0
            let isFinishM = 0

            let onTravelC = 0
            let onBoardingC = 0
            let isFinishC = 0

            let onTravelP = 0
            let onBoardingP = 0
            let isFinishP = 0
            snap.forEach(element => {
                let datos = element.val();
                let fechaActu = new Date();
                let fechaActuProv = fechaActu.getFullYear() + '/' + (fechaActu.getMonth() + 1) + '/' + fechaActu.getDate()
                let fechaActuB = new Date(fechaActuProv)
                let fechaProv = new Date(datos.fecha);
                let armarda = fechaProv.getFullYear() + '/' + (fechaProv.getMonth() + 1) + '/' + fechaProv.getDate()
                let fechaRegi = new Date(armarda);
                if (fechaActuB.getTime() === fechaRegi.getTime()) {
                    if (datos.tipoVe === 'Taxi') {
                        if (datos.viajeIniciado === true && datos.viajeFinalizado !== true) {
                            onTravelT = onTravelT + 1;
                        }
                        if (datos.viajeIniciado === false && datos.viajeFinalizado !== true) {
                            onBoardingT = onBoardingT + 1;
                        }
                        if (datos.viajeFinalizado === true) {
                            isFinishT = isFinishT + 1;
                        }
                    }
                    if (datos.tipoVe === 'Microbus') {
                        if (datos.viajeIniciado === true && datos.viajeFinalizado !== true) {
                            onTravelM = onTravelM + 1;
                        }
                        if (datos.viajeIniciado === false && datos.viajeFinalizado !== true) {
                            onBoardingM = onBoardingM + 1;
                        }
                        if (datos.viajeFinalizado === true) {
                            isFinishM = isFinishM + 1;
                        }
                    }
                    if (datos.tipoVe === 'Privado') {
                        if (datos.viajeIniciado === true && datos.viajeFinalizado !== true) {
                            onTravelP = onTravelP + 1;
                        }
                        if (datos.viajeIniciado === false && datos.viajeFinalizado !== true) {
                            onBoardingP = onBoardingP + 1;
                        }
                        if (datos.viajeFinalizado === true) {
                            isFinishP = isFinishP + 1;
                        }
                    }
                    if (datos.tipoVe === 'Coaster') {
                        if (datos.viajeIniciado === true && datos.viajeFinalizado !== true) {
                            onTravelC = onTravelC + 1;
                        }
                        if (datos.viajeIniciado === false && datos.viajeFinalizado !== true) {
                            onBoardingC = onBoardingC + 1;
                        }
                        if (datos.viajeFinalizado === true) {
                            isFinishC = isFinishC + 1;
                        }
                    }
                }
            });
            this.setState({
                onTravelT, onBoardingT, isFinishT, onTravelP, onBoardingP, isFinishP,
                onTravelM, onBoardingM, isFinishM, onTravelC, onBoardingC, isFinishC
            })
        })
    }

    getTravels = () => {

        firebase.database().ref('AsignacionViajes').on('value', snap => {
            let index = 0;
            snap.forEach(element => {
                let datos = element.val();
                let fechaActu = new Date();
                let fechaActuProv = fechaActu.getFullYear() + '/' + (fechaActu.getMonth() + 1) + '/' + fechaActu.getDate()
                let fechaActuB = new Date(fechaActuProv)
                let fechaProv = new Date(datos.fecha);
                let armarda = fechaProv.getFullYear() + '/' + (fechaProv.getMonth() + 1) + '/' + fechaProv.getDate()
                let fechaRegi = new Date(armarda);
                if (fechaActuB.getTime() === fechaRegi.getTime()) {
                    firebase.database().ref('EmpleadosGPS/' + datos.conduc).on('value', snap2 => {
                        let empleado = snap2.val();
                        datos.conduc2 = { lat: empleado.latitud, lng: empleado.longitud }
                        datos.key = element.key;
                        this.darValores(index);
                        this.setState({ viajes: [...this.state.viajes, datos] });
                        index = index + 1;
                    })
                }
            });
        });
    }


    componentDidMount(id) {
        this.cargarViajes();
        this.getTravels();
    }

    darValores = (index) => {
        let id3 = 'emple' + index;
        this.setState({ [id3]: false });
    }

    onToggleOpenV = (index, obje) => {
        let id3 = 'emple' + index;
        this.setState({ [id3]: !this.state[id3], isLoading: true, });
        firebase.database().ref('Empleados/' + obje.conduc).once('value').then(snap => {
            let datos = snap.val();
            firebase.database().ref('Vehiculos/' + datos.vehiculo).once('value').then(snaphopt => {
                let vehi = snaphopt.val();
                firebase.database().ref('AsignacionViajes/' + obje.key).once('value').then(dataV => {
                    let estado = dataV.val();
                    firebase.database().ref('AsignacionViajes/' + obje.key + '/emple').on('value', snap2 => {
                        let nombres = [];
                        datos.movil = obje.movil;
                        datos.placa = vehi.placa;
                        if (estado.viajeIniciado === true && estado.viajeFinalizado !== true) {
                            datos.estado = 'En viaje';
                        }
                        if (estado.viajeIniciado === false && estado.viajeFinalizado !== true) {
                            datos.estado = 'Abordando';
                        }
                        if (estado.viajeFinalizado === true) {
                            datos.estado = 'Finalizado';
                        }
                        this.setState({ condV: datos, empleV: [] });
                        snap2.forEach(element => {
                            let emple = element.val();
                            firebase.database().ref('Clientes/' + emple.idEmple).once('value').then(snap3 => {
                                let clien = snap3.val();
                                clien.estado = emple.subio;
                                this.setState({ empleV: [...this.state.empleV, clien] });
                            })
                        });
                    })
                })
            })
        })
        setTimeout(() => {
            this.setState({ isLoading: false })
        }, 2000);
    }

    onToggleOpenVC = (index) => {
        let id3 = 'emple' + index;
        this.setState({ [id3]: false });
    }

    render() {
        let { onTravelT, onBoardingT, isFinishT, onTravelP, onBoardingP, isFinishP,
            onTravelM, onBoardingM, isFinishM, onTravelC, onBoardingC, isFinishC, viajes, empleV, condV,
            isLoading } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-8 m-bottom">
                        <GoogleMap
                            defaultZoom={12}
                            defaultCenter={{ lat: 13.6988044, lng: -89.2507203 }}
                        >
                            {this.state.viajes.map((snap, index) => {
                                return (
                                    <div key={'markers' + index}>
                                        {snap.tipoVe === 'Taxi' &&

                                            <Marker key={'keyM' + index} onClick={() => this.onToggleOpenV(index, snap)} key={'marker' + index} icon={Taxi} position={snap.conduc2} >
                                                {
                                                    this.state['emple' + index] &&
                                                    <InfoWindow onCloseClick={() => this.onToggleOpenVC(index)}>
                                                        <div>
                                                            {' '}
                                                            {snap.movil}
                                                        </div>
                                                    </InfoWindow>
                                                }
                                            </Marker>
                                        }
                                        {snap.tipoVe === 'Privado' &&
                                            <Marker key={'keyM' + index} onClick={() => this.onToggleOpenV(index, snap)} key={'marker' + index} icon={Privado} position={snap.conduc2} >
                                                {
                                                    this.state['emple' + index] &&
                                                    <InfoWindow onCloseClick={() => this.onToggleOpenVC(index)}>
                                                        <div>
                                                            {' '}
                                                            {snap.movil}
                                                        </div>
                                                    </InfoWindow>
                                                }
                                            </Marker>
                                        }
                                        {snap.tipoVe === 'Microbus' &&
                                            <Marker key={'keyM' + index} onClick={() => this.onToggleOpenV(index, snap)} key={'marker' + index} icon={Microbus} position={snap.conduc2} >
                                                {
                                                    this.state['emple' + index] &&
                                                    <InfoWindow onCloseClick={() => this.onToggleOpenVC(index)}>
                                                        <div>
                                                            {' '}
                                                            {snap.movil}
                                                        </div>
                                                    </InfoWindow>
                                                }
                                            </Marker>
                                        }
                                        {snap.tipoVe === 'Coaster' &&
                                            <Marker key={'keyM' + index} onClick={() => this.onToggleOpenV(index, snap)} key={'marker' + index} icon={Taxi} position={snap.conduc2} >
                                                {
                                                    this.state['emple' + index] &&
                                                    <InfoWindow onCloseClick={() => this.onToggleOpenVC(index)}>
                                                        <div>
                                                            {' '}
                                                            {snap.movil}
                                                        </div>
                                                    </InfoWindow>
                                                }
                                            </Marker>
                                        }
                                    </div>
                                )
                            })}
                        </GoogleMap>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 fixPosition">
                        <div className="row">
                            <div className="col-12 col-md-6 col-lg-6 text-center bg-card">
                                <img className="img-margin-top" src={TaxiIcon} />
                                <h6>Abordando</h6>
                                <p>{onBoardingT}</p>
                                <h6>En viaje</h6>
                                <p>{onTravelT}</p>
                                <h6>Finalizados</h6>
                                <p>{isFinishT}</p>
                            </div>
                            <div className="col-12 col-md-6 col-lg-6 text-center bg-card">
                                <img className="img-margin-top" src={PrivadoIcon} />
                                <h6>Abordando</h6>
                                <p>{onBoardingP}</p>
                                <h6>En viaje</h6>
                                <p>{onTravelP}</p>
                                <h6>Finalizados</h6>
                                <p>{isFinishP}</p>

                            </div>
                            <div className="col-12 col-md-6 col-lg-6 text-center bg-card">
                                <img className="img-margin-top" src={MicroIcon} />
                                <h6>Abordando</h6>
                                <p>{onBoardingM}</p>
                                <h6>En viaje</h6>
                                <p>{onTravelM}</p>
                                <h6>Finalizados</h6>
                                <p>{isFinishM}</p>
                            </div>
                            <div className="col-12 col-md-6 col-lg-6 text-center bg-card">
                                <img className="img-margin-top" src={CoasterIcon} />
                                <h6>Abordando</h6>
                                <p>{onBoardingC}</p>
                                <h6>En viaje</h6>
                                <p>{onTravelC}</p>
                                <h6>Finalizados</h6>
                                <p>{isFinishC}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {!isLoading &&
                            <div>
                                <div className="row font-small">
                                    <div class="col-md-3 col-12">
                                        <div className="form-   group">
                                            {/*<input type="text" className="form-control font-small form-cursive" placeholder="Buscar por unidad,conductor,pasajero..."/>*/}
                                        </div>
                                    </div>
                                    <div class="col">
                                        <b>Detalle de unidad</b>
                                        {condV.tipo_vehiculo === 'Taxi' &&
                                            <div> <img src={TaxiIcon} /> {condV.movil}</div>
                                        }
                                        {condV.tipo_vehiculo === 'Privado' &&
                                            <div> <img src={PrivadoIcon} /> {condV.movil}</div>
                                        }
                                        {condV.tipo_vehiculo === 'Microbus' &&
                                            <div> <img src={MicroIcon} /> {condV.movil}</div>
                                        }
                                        {condV.tipo_vehiculo === 'Coaster' &&
                                            <div> <img src={CoasterIcon} /> {condV.movil}</div>
                                        }
                                        <b style={{ marginLeft: '50px' }}>Estado: {condV.estado}</b>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className='col-12 col-sm-12 col-md-4'>
                                        <p className='textInfo'>Conductor: {condV.nombre}</p>
                                        <p className='textInfo'>Velocidad: {empleV.velocidad} km/h</p>
                                        <p className='textInfo'>Tiempo para llegar a destino: 45 min</p>
                                        <p className='textInfo'>Pasajeros: {empleV.length}</p>
                                    </div>
                                    <div className='col-12 col-sm-12 col-md-6 flexD'>

                                        {

                                            empleV.map((snap, index) => {
                                                return (
                                                    <div style={{ width: '37%', height: 20 }}>
                                                        {snap.estado === false &&
                                                            <p style={{ fontFamily: 'roboto', fontSize: 12, color: 'red' }} key={'pasa' + index} >{snap.nombre} {snap.apellido}</p>
                                                        }
                                                        {snap.estado === true &&
                                                            <p style={{ fontFamily: 'roboto', fontSize: 12, color: '#6F7979' }} key={'pasa' + index} >{snap.nombre} {snap.apellido}</p>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-2">
                                        {/*<button class="btn btn-orange-black">Modificar estado</button>*/}
                                    </div>
                                </div>
                            </div>
                        }
                        {isLoading &&
                            <div className='centro'>
                                <Eye />
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}
export default withGoogleMap(UnidadesViajes);


// WEBPACK FOOTER //
// ./src/Components/PlanificacionE/unidades.js